import { MY_ASTER_CATEGORY, PAGE_NAME, PAGE_TYPE } from '@common/Constants/analytics';
import { dataLayerSendEvent as sendEventDaata } from '../../../Common/Utility/analytics-utils';
import { SCREEN_NAME } from '@common/Utility/constants';
import { convertTimeToHHMMSS, formatDateToYearMonthDate } from '@common/Utility/date-utils';
import moment from 'moment';

export const dataLayerSendEvent = (eventName, data) => {
  sendEventDaata(eventName, data);
};

export const instantGPBannerImpression = (screen) => {

  const getScreenName = () => {
    if (screen === 'Teleconsult') {
      return SCREEN_NAME?.AT;
    } else  if (screen === 'Core'){
      return SCREEN_NAME?.ASCO;
    }
  };

  const parameter = {
    screen_name: getScreenName(),
    page_type: PAGE_TYPE?.HOME,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    banner_name: 'Instant gp banner',
  };

  dataLayerSendEvent('banner_impression', parameter);
};

export const instantGPBannerClick = (screen) => {

  const getScreenName = () => {
    if (screen === 'Teleconsult') {
      return SCREEN_NAME?.AT;
    } else  if (screen === 'Core'){
      return SCREEN_NAME?.ASCO;
    }
  };

  const parameter = {
    screen_name: getScreenName(),
    page_type: PAGE_TYPE?.HOME,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };

  dataLayerSendEvent('instant_gp_banner_click', parameter);
};

export const instantGpPageView = (referrerPage, availableInMinutes, startTime) => {
  const durationInSeconds = moment.parseZone(startTime).local().diff(moment.parseZone(new Date()).local(), 'seconds');
  const timeInMinutes = Math.ceil(durationInSeconds / 60);
  const [availableInMinute, availableString] = availableInMinutes?.split(' ');
  const itemData = {
    screen_name: SCREEN_NAME?.INSTANTGP_INFORMATION,
    page_type: PAGE_NAME?.INSTANTGP,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    referrer_page: referrerPage,
    available_in_minutes: timeInMinutes > 60 ? availableInMinutes : Number(availableInMinute),
  };
  dataLayerSendEvent('page_view', itemData);
};

export const instantGpHomepageContinue = (doctorData, availableInMinutes, referrerPage, isAvailable) => {
  const [availableMinute, availableString] = availableInMinutes?.split(' ');
  const itemData = {
    screen_name: SCREEN_NAME?.INSTANTGP_INFORMATION,
    page_type: PAGE_NAME?.INSTANTGP,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    doctor_name: doctorData?.[0]?.name,
    speciality: doctorData?.[0]?.specialization,
    available_in_minutes: isAvailable ? Number(availableMinute) : availableInMinutes,
    referrer_page: referrerPage,
  };
  dataLayerSendEvent('continue_clicked_instantgp', itemData);
};

export const doctorCardClickInstantGP = (doctorData, availableInMinutes, referrerPage) => {
  const [availableMinute, availableString] = availableInMinutes?.split(' ');
  const itemData = {
    screen_name: SCREEN_NAME?.INSTANTGP_INFORMATION,
    page_type: PAGE_NAME?.INSTANTGP,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    doctor_name: doctorData?.[0]?.name,
    speciality: doctorData?.[0]?.specialization,
    available_in_minutes: Number(availableMinute),
    referrer_page: referrerPage,
  };
  dataLayerSendEvent('doctor_selected_instantgp', itemData);
};

export const instantGpBookAppointment = (doctorData, availableInMinutes, details, paymentType, isAvailable) => {
  const [availableMinute, availableString] = availableInMinutes?.split(' ');
  const itemData = {
    screen_name: SCREEN_NAME?.INSTANTGP_CHECKOUT,
    facility_type: doctorData?.[0]?.facilityDetails?.[0]?.clinicType,
    doctor_name: doctorData?.[0]?.name,
    speciality: doctorData?.[0]?.specialization,
    available_in_minutes: Number(availableMinute),
    payment_amount: Number(details?.paymentAmount),
    payment_method: details?.payerType,
    payment_type: paymentType?.toLowerCase(),
    insurance_provider: details?.payerType === 'Insurance' ? details?.insuranceProvider : '',
    insurance_network: details?.payerType === 'Insurance' ? details?.insuranceNetwork : '',
    secure_points_earned: Number(details?.loyaltyPointsEarned),
    appointment_date: formatDateToYearMonthDate(details?.appointmentDate),
    appointment_time: convertTimeToHHMMSS(details?.appointmentTime),
    insurance_coverage: !!details?.isInsuranceCovered,
    appointment_mode: 'video consultation',
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT, 
    facility_name: doctorData?.[0]?.facilityDetails?.[0]?.name,
    currency:'AED',
    available_in_minutes: isAvailable ? Number(availableMinute) : availableInMinutes,
  };
  dataLayerSendEvent('book_appointment_clicked_instantgp', itemData);
};

export const addPaymentInfoInitiatedInstantGP = ( details, paymentType ) => {

  const itemData = {
    screen_name: SCREEN_NAME?.INSTANTGP_CHECKOUT,
    booking_type: 'Instant gp booking',
    payment_method: details?.payerType,
    payment_type: paymentType?.toLowerCase(),
    currency: 'AED',
    payment_amount: Number(details?.paymentAmount),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('add_payment_info_initiated', itemData);
};

export const bookAppointmentErrorInstantGP = (details, paymentType, errorType) => {

  const itemData = {
    screen_name: SCREEN_NAME?.INSTANTGP_CHECKOUT,
    facility_name: details?.facilityName,
    facility_type: details?.facilityType,
    payment_type: paymentType?.toLowerCase(),
    payment_method: details?.payerType,
    payment_amount: Number(details?.paymentAmount),
    error: 'Something went wrong',
    error_type: errorType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('book_appointment_error', itemData);
};

export const selectInsuranceInInstantGP = (details) => {
  const itemData = {
    screen_name: SCREEN_NAME?.INSTANTGP_CHECKOUT,
    page_type: PAGE_NAME?.INSTANTGP,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    insurance_provider: details?.resource?.policyHolder?.display,
    insurance_network: details?.resource?.class?.find(item => item?.type?.coding?.find(coding => coding?.code === 'PlanCode'))?.name,
    insurance_coverage: details?.resource?.extension?.find((x) => x?.url === 'isInsuranceCovered')?.valueBoolean,
  };
  dataLayerSendEvent('select_insurance', itemData);
};